<template>
  <div
    v-if="contents.status"
    class="w-100 mt-2 px-3 px-lg-10 pt-lg-5 d-flex justify-content-between align-items-center col-3"
  >
  <!-- :href="`${backendHost}?locale=${currentLocale}` -->
  <a class="mh-250px mh-lg-150px mw-50 mw-lg-25" :href="`https://devcore.websiran.com/?pid=${$store.state.uploadsPath.split('.')[0]}`">
    <img
      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${$store.state.logos.mainLogo}`"
      style="width: 100%"
    />
  </a>
    <div v-if="localeStatus && locales.length > 1" class="w-25">
      <multiselect
        class=""
        v-model="locale"
        :options="locales"
        :hideSelected="true"
        :canClear="false"
        label="locale"
        @select="setCurrentLocale"
      >
        <template v-slot:option="{ option }">
          <img
            style="width: 25px"
            class="me-2 rounded-circle"
            :src="`${backendHost}/images/svg/flags/${option.image}`"
          />
          {{ option.locale }}
        </template>
      </multiselect>
    </div>
  </div>
</template>

<script>
// import dataService from "../../../services/data";
import Multiselect from "@vueform/multiselect";
import serverConfigs from "../../../configs/server.json";

export default {
  setup() {},
  props: {
    localeStatus: {
      type: Boolean,
    },
  },
  components: {
    multiselect: Multiselect,
  },
  computed: {
    backendHost() {
      return serverConfigs["serverDomain"]["host"];
    },
    currentPath() {
      return this.$route.path;
    },
    currentLocale() {
      return this.$route.params.locale;
    },
  },
  data() {
    return {
      contents: {
        status: true,
      },
      locale: null,
      locales: [],
      logos: {},
    };
  },
  methods: {
    setCurrentLocale() {
      localStorage.setItem("locale", this.locale);
      window.location = `/${this.locale}/${String(this.currentPath).substring(
        4
      )}`;
    },
    setLanguages() {
      if (this.locales.length == 0) {
        for (let d in this.$store.state.languages.value) {
          this.locales.push(this.$store.state.languages.value[d]);
          this.locales[d]["value"] =
            this.$store.state.languages.value[d].locale;
          if (
            this.$store.state.languages.value[d].locale == this.currentLocale
          ) {
            this.locale = this.$store.state.languages.value[d].locale;
            localStorage.setItem(
              "locale",
              this.$store.state.languages.value[d].locale
            );
          }
        }
      }
      // if (this.locale == null) {
      //   localStorage.setItem("locale", this.$store.state.languages.default);
      //   window.location = "/";
      // }
    },
  },
  mounted() {
    // this.setLanguages();
  },
  updated() {
    this.setLanguages();
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>